import { TRUE, FALSE, DISPUTED, ASSUMED } from './Status';

export function getStatusColorClass(status) {
    switch (status.toLowerCase()) {
        case TRUE: return 'trueColor';
        case FALSE: return 'falseColor';
        case DISPUTED: return 'disputedColor';
        case ASSUMED: return 'assumedColor';
    }
    return null;
}

export function getStatusBackgroundColorClass(status) {
    switch (status.toLowerCase()) {
        case TRUE: return 'trueBackgroundColor';
        case FALSE: return 'falseBackgroundColor';
        case DISPUTED: return 'disputedBackgroundColor';
        case ASSUMED: return 'assumedBackgroundColor';
    }
    return null;
}

export function getStatusIconClass(status) {
    switch (status.toLowerCase()) {
        case TRUE: return 'check';
        case FALSE: return 'times';
        case ASSUMED: return 'question';
        default: return 'exclamation';
    }
}

export function getStatusTitle(status) {
    switch (status.toLowerCase()) {
        case TRUE: return 'True';
        case FALSE: return 'False';
        case DISPUTED: return 'Disputed';
        case ASSUMED: return 'Assumed';
    }
}